import { ethers } from 'ethers';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { IState } from '../models/reducers/i-state.interface';

import { setReferrerWallet } from '../actions/wallet.action';

export const useReferrerWallet = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const storedReferrerWallet = useSelector((state: IState) => state.wallet.referrerWallet);
  const searchParams = new URLSearchParams(location.search);
  const urlReferrerWallet = searchParams.get('referrerWallet');

  // Store referrerWallet from URL in Redux if valid and not already stored
  useEffect(() => {
    if (urlReferrerWallet && urlReferrerWallet !== storedReferrerWallet) {
      const isValid = ethers.utils.isAddress(urlReferrerWallet);
      if (isValid) {
        dispatch(setReferrerWallet(urlReferrerWallet));
      }
    }
  }, [urlReferrerWallet, storedReferrerWallet, dispatch]);

  // Persist referrerWallet in URL across all routes if it exists in Redux
  useEffect(() => {
    if (storedReferrerWallet && !urlReferrerWallet) {
      const newSearchParams = new URLSearchParams(location.search);
      newSearchParams.set('referrerWallet', storedReferrerWallet);

      navigate(
        {
          pathname: location.pathname,
          search: `?${newSearchParams.toString()}`,
        },
        { replace: true }
      );
    }
  }, [location.pathname, location.search, storedReferrerWallet, urlReferrerWallet, navigate]);
};
